import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ArticleListPage from './pages/ArticleListPage';
import ArticlePage from './pages/ArticlePage';
import VideosPage from './pages/VideosPage';
import VideoPage from './pages/VideoPage';
import ShortsPage from './pages/ShortsPage';
import ShortDetailPage from './pages/ShortDetailPage';
import CoversPage from './pages/CoversPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdvertisePage from './pages/AdvertisePage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminArticles from './pages/admin/AdminArticles';
import AdminVideos from './pages/admin/AdminVideos';
import AdminShorts from './pages/admin/AdminShorts';
import AdminCovers from './pages/admin/AdminCovers';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminSettings from './pages/admin/AdminSettings';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import './App.css';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/features" element={<CategoryPage />} />
            <Route path="/interviews" element={<CategoryPage />} />
            <Route path="/brands" element={<CategoryPage />} />
            <Route path="/creators" element={<CategoryPage />} />
            <Route path="/articles/:slug" element={<ArticlePage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/videos/:slug" element={<VideoPage />} />
            <Route path="/shorts" element={<ShortsPage />} />
            <Route path="/shorts/:id" element={<ShortDetailPage />} />
            <Route path="/covers" element={<CoversPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/advertise" element={<AdvertisePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/articles" element={<AdminArticles />} />
            <Route path="/admin/videos" element={<AdminVideos />} />
            <Route path="/admin/shorts" element={<AdminShorts />} />
            <Route path="/admin/covers" element={<AdminCovers />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Routes>
          <Toaster theme="dark" />
        </div>
      </Router>
    </HelmetProvider>
  );
}